import { evaluate, round } from 'mathjs';

export const formatNumber = (value: number | null, language: string) => {
    if (!value && value !== 0) {
        return null;
    }
    const locale = language === 'en' ? 'en-US' : 'de-DE';
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
}

export const formatIntNumber = (value: number | null, language: string) => {
    if (!value && value !== 0) {
        return null;
    }
    const locale = language === 'en' ? 'en-US' : 'de-DE';
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
}

export const formatPercentNumber = (value: number | null, language: string) => {
    if (!value && value !== 0) {
        return null;
    }
    const locale = language === 'en' ? 'en-US' : 'de-DE';
    const amount =  new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
    return language === 'en' ? '% ' + amount : amount + ' %';
}

export const formatCurrency = (value: number | null, language: string) => {
    if (!value && value !== 0) {
        return null;
    }
    value = round(value, 10)
    const locale = language === 'en' ? 'en-US' : 'de-DE';
    const amount =  new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
    return language === 'en' ? '€ ' + amount : amount + ' €';
}

export const formatIntCurrency = (value: number | null, language: string) => {
    if (!value && value !== 0) {
        return null;
    }
    value = round(value, 10)
    const locale = language === 'en' ? 'en-US' : 'de-DE';
    const amount =  new Intl.NumberFormat(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value);
    return language === 'en' ? '€ ' + amount : amount + ' €';
}
